import _ from "lodash"
import $$Rangers from "@datarangers/sdk-mp" // 火山微信小程序的sdk
import $router from "../common/uni-router"
import { Volcengine } from "../common"
import { checkInitParams } from "./validate"
export default class WxmpVolcengine extends Volcengine {
  constructor(param) {
    const initParams = _.isEmpty(param) ? {} : _.isObject(param) ? param : {}
    initParams.type = 2
    // 表示是微信小程序端的SDK
    super(initParams)
    try {
      this.wxmpPlugins = $$Rangers
      this.routerInfo = UNI_ROUTES.pages
      this.tarBar = UNI_ROUTES.tarBar ? UNI_ROUTES.tarBar.list : []
      this.isInitWXMPSdk = false
      this.initWXMPSdk(param)
    } catch (e) {
    }
  }
  // 开始写入路由、访问时间、访问路径的缓存到系统缓存中
  start() {
    if (this.isInitWXMPSdk) {
      if (UNI_ROUTES.subPackages) {
        this.handleSubPackagesList(UNI_ROUTES.subPackages)
      }
      this.init(this.routerInfo, this.tarBar)
    }
  }

  // 监听路由变更
  listenRouter(param) {
    if (this.isInitWXMPSdk) {
      if (!_.isObject(param)) {
        param = {}
      }
      $router.onchange = (n, o) => {
        if (!this.isVolcengine) {
          return
        }
        try {
          const lastVisitUrl = this.getCacheVisitUrl()
          const nowPath = n.fullPath
          if (lastVisitUrl === nowPath) {
            return
          }
          this.setCacheVisitUrl(nowPath)
          this.customPageview(o.fullPath, param)
        } catch (e) {}
      }
    }
  }

  // 初始化
  initWXMPSdk(param) {
    const isValid = checkInitParams(param)
    if (isValid) {
      if (!param.enable_profile) {
        param.enable_profile = true
      }
      if (!param.enable_filter_crawler) {
        param.enable_filter_crawler = true
      }
      this.wxmpPlugins.init(param)
      this.wxmpPlugins.send()
      this.isInitWXMPSdk = true
    }
  }

  /**
   * 接口采集事件
   * @param {*} param
   */
  collectApi(param) {
    if (!this.isInitWXMPSdk) {
      return
    }
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    const currentUrl = this.pages[0]
    const commonAttr = this.getCommonAttr(currentUrl)
    const collectParam = {}
    Object.keys(param).forEach((key) => {
      let targetKey = key
      if (["apiName", "isSuccess", "apiTimeCost"].includes(key)) {
        targetKey = key.replace(
          /[A-Z]/g,
          (key) => `_${key.toLowerCase()}`
        )
      }
      collectParam[targetKey] = param[key]
    })
    const finalParam = {
      ...commonAttr,
      ...collectParam
    }
    this.wxmpPlugins.event("api_request", finalParam)
  }
  customPageviewLaunch(param) {
    if (this.getIsLaunch() || this.getIsHide()) {
      const currentUrl = this.getCacheVisitUrl()
      this.setIsHide(false)
      this.customPageview(currentUrl, param)
    }
    this.setIsLaunch(true)
  }
  customPageviewOpen(param) {
    const that = this
    this.setIsLaunch(true) // 不然会出现关闭之后进入首页在刷新，没有上报停留时间
    setTimeout(function() {
      that.setIsHide(false)
      that.handleCustomPageviewOpen(param)
    }, 500)
  }
  // 监听初始化进入页面
  handleCustomPageviewOpen(param) {
    if (!this.isInitWXMPSdk) {
      return
    }
    if (!_.isObject(param)) {
      param = {}
    }
    try {
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      let currentUrl
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      } else {
        // 获取不到当前页面只能取首页了
        currentUrl = "/" + this.routerInfo[0].path
      }
      const nowTime = new Date().getTime()
      this.setCacheTime(nowTime) // 重新记录页面停留时间
      this.setCacheVisitUrl(currentUrl)

      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }

      const commonAttr = this.getCommonAttr(currentUrl)
      const finalParam = {
        ...commonAttr,
        ...param
      }
      this.wxmpPlugins.event("custom_pageview_open", finalParam)
    } catch (e) {
    }
  }

  /**
   * 监听隐藏页面
   * @param
   * @returns
   */
  customPageviewHide(param) {
    try {
      if (!_.isObject(param)) {
        param = {}
      }
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      let currentUrl = this.getCacheVisitUrl()
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + this.routerInfo[0].path
      }

      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      const commonAttr = this.getCommonAttr(currentUrl)
      const finalParam = {
        ...commonAttr,
        ...param
      }

      this.wxmpPlugins.event("custom_pageview_hide", finalParam)
      // 上报当前页面的停留时间，然后onShow的时候会重新改写当前页面访问时间
      this.customPageview(currentUrl, param)
      this.setIsLaunch(false)
      this.setIsHide(true)
    } catch (e) {
    }
  }
  /**
   * 用户上报火山自定义事件
   * @param {*} name 自定义的事件名称
   * @param {*} param 自定义的事件参数
   * @returns
   */
  reportEvent(name, param) {
    // 防止 自定义 custom_pageview 事件的时候没有执行对应逻辑
    const oldPath =
      this.pages && this.pages.length ? this.pages[0] : this.routerInfo[0].path
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    const currentUrl = this.pages[0]
    if (name === "custom_pageview") {
      this.setCacheVisitUrl(oldPath, param)
    }
    const commonAttr = this.getCommonAttr(currentUrl)
    const finalParam = {
      ...commonAttr,
      ...param
    }
    try {
      this.wxmpPlugins.event(name, finalParam)
    } catch (e) {}
  }

  setUserUniqueId(paramUserUniqueId) {
    if (!this.isInitWXMPSdk) {
      return
    }
    const userUniqueId = paramUserUniqueId || this.nullProp
    try {
      this.wxmpPlugins.setUserUniqueID(userUniqueId)
    } catch (e) {}
  }

  /**
   * 设置用户属性
   * @param {*} profileParam 用户属性
   * @returns
   */
  profileSet(profileParam) {
    try {
      this.wxmpPlugins.profileSet(profileParam)
    } catch (e) {}
  }
  sdkVersionProfileSet(param) {
    try {
      const sdkVersion = this.getSdkVersion()
      const finalParam = {
        ...param,
        ...sdkVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  appVersionProfileSet(param) {
    try {
      const appVersion = this.getAppVersion()
      const finalParam = {
        ...param,
        ...appVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  /**
   * 上报页面访问事件
   * @param {*} path 路径
   * @param {*} param 用户自定义的参数
   */
  customPageview(path, param) {
    if (!this.volcengineProps[path]) {
      this.updateRouter(this.routerInfo, this.tarBar)
    }
    const lastPageVisitTime = this.getCacheTime()
    const nowTime = new Date().getTime()
    this.setCacheTime(nowTime)
    const commonAttr = this.getCommonAttr(path)
    const isHide = this.getIsHide()
    const durationParam = {
      custom_page_duration: isHide ? 0 : (nowTime - lastPageVisitTime)
    }
    const finalParam = {
      ...commonAttr,
      ...durationParam,
      ...param
    }
    this.setIsHide(false)
    this.wxmpPlugins.event("custom_pageview", finalParam)
  }
  handleSubPackagesList(packageList) {
    packageList.forEach((element) => {
      const rootPath = element.root + "/"
      if (element.pages && element.pages.length) {
        element.pages.forEach((item) => {
          const subItem = item
          subItem.path = rootPath + item.path
          this.routerInfo.push(subItem)
        })
      }
    })
  }
}
